import styled from 'styled-components';
import { Colors } from '../../shared/colors/colors';

// Contêiner principal da paginação
export const PaginationWrapper = styled.div`
  margin: 10px auto; /* Margem externa (20px no topo e na base, centralizado horizontalmente) */
  padding: 16px; /* Padding igual em todos os lados */
  border: 1px solid #ddd; /* Borda discreta ao redor */
  border-radius: 12px; /* Bordas arredondadas */
  width: fit-content; /* Tamanho do contêiner ajustado ao conteúdo */
`;

// Contêiner dos botões de paginação
export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px; /* Espaçamento entre os botões */
`;

// Estilo dos botões
export const PaginationButton = styled.button`
  padding: 8px 12px;
  border: 1px solid #ccc;
  background-color: ${Colors.white};
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.3s ease;

  /* Efeito hover nos botões */
  &:hover:not(:disabled) {
    background-color: ${Colors.primary};
    color: white;
    border-color: ${Colors.primary};
  }

  /* Botão desabilitado */
  &:disabled {
    background-color: #e0e0e0;
    cursor: not-allowed;
    color: #999;
  }

  /* Estilo do botão ativo (página atual) */
  &.active {
    background-color:${Colors.primary};
    color: white;
    border-color: ${Colors.primary};
  }
`;